import Cookies from 'js-cookie'

const Key = {Admin: 'Bot-Pass-data', Login: 'Bot-Pass-logined', LineNotify: 'Line_Registered_Msg'}
Object.values(Key)

export function getCookies(name) {    
    return Cookies.get(Key[name])
}

export function setCookies(name, data) {
    return Cookies.set(Key[name], data, "2h")
}

export function removeCookies(name) {
    return Cookies.remove(Key[name])
}